export default function (state,getters,rootState, rootGetters) {
    return rootGetters['dictionaries/cash/select/list'];
}